import { render, staticRenderFns } from "./certify.vue?vue&type=template&id=e96dd05e&scoped=true&"
import script from "./certify.vue?vue&type=script&lang=js&"
export * from "./certify.vue?vue&type=script&lang=js&"
import style0 from "./certify.vue?vue&type=style&index=0&id=e96dd05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96dd05e",
  null
  
)

export default component.exports